import(/* webpackMode: "eager" */ "/vercel/path0/ui/src/app/[[...marketSymbol]]/page.tsx");
